import $ from 'jquery'
import page from '../../../components/page.vue'
import {api,imgPath} from "../../../common/config";
import {store} from '../../../store/store.js'
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';
import loginmask from '../../../components/loginmask.vue';
import videoPlay from '../../../components/videoPlay.vue'
export default {
    name: 'infordetails',
    data(){
        return {
          imgPath:imgPath,
            flagPraise: false,
            isOne: 0,
            last: 0,
            praiseCount: 0,//点赞数量
            isPraise: false,//是否取消点赞,true点赞,false取消(资讯点赞)
            isPraiseComment: false,//是否取消点赞,true点赞,false取消(评论点赞)
            readers: 0,//阅读数量
            content: '',//评论
            isLogin: false,
            msgList: [
                {
                    isReply: false,//是否出现回复框
                    isList: false,//是否出现回复列表
                    replyList: [{isReply: false}, {isReply: false}],//回复列表
                },
                {
                    isReply: false,
                    isList: false,//是否出现回复列表
                    replyList: [{isReply: false}, {isReply: false}],//回复列表
                }
            ],
            pubReplyData: {
                commentId: '',//	资讯评论ID	number	回复"评论"时传入此参数 二选一
                content: '',//	回复内容
                readerId: 0,//读者ID
                replyId: 0//回复"读者"时传入此参数 二选一
            },
            replyMsg: '',
            dataInfo: null,
            delId: 0,
            delNewsId: 0,
            isDelComment: false,
            isDel: false,
            delIsClose: false,
            replyCommentFlag: 0,//1弹出回复框
            flag: 0, //1:回复评论，2为回复读者
            createTime: '',
            commentShow: 0,
            newsDot: false,//资讯点赞,用于网络抖动,防止重复点击
            commentDot: false,//资讯评论点赞,用于网络抖动,防止重复点击
            zanedDot: false,//资讯回复点赞,用于网络抖动,防止重复点击
            submitNewsData: {
                content: '',//资讯评论内容
                id: '',
                newsId: '',
            },
            pageNo: 1,
            commentData: {},
            totalPage: 0,
            commentPageCount: 4,
            idCard: '',
            readerId: '',
            informationData: {},
            isMsg: false,
            newsId: 0,
            fromSearch: 0,
            libCode: '',
            opacType: store.opacType
        }
    },
    components: {
        page,
        videoPlay,
        loginmask
    },
    beforeRouteLeave(to, from, next) {
        if ($('#bdshare_weixin_qrcode_dialog')) {/*关闭分享组件微信分享页面*/
            $('#bdshare_weixin_qrcode_dialog').hide();
        }
        next()
    },

    beforeMount() {
        store.wrap.activeRouteName = '资讯';
    },
    watch: {
        $route() {
            this.newsId = this.$route.query.newsId;
            this.fromSearch = this.$route.query.fromSearch;
            this.libCode = this.$route.query.hallCode || '';
        }
    },
    mounted() {
        this.queryData();
    },
    methods: {
        queryData(){
            this.libCode = this.$route.query.hallCode || '';
            this.idCard = store.func.getUserObj() ? store.func.getUserObj().idCard : '';
            this.readerId = store.func.getUserObj() ? store.func.getUserObj().readerId : '';
            this.newsId = this.$route.query.newsId;
            this.fromSearch = this.$route.query.fromSearch;
            Promise.all([this.informationDataList(), this.commentDataList()]).then(() => {
                this.isLogin = store.func.getUserObj() ? true : false;
                this.dataInfo = StorageUtil.getObject("informationInfo");
                let index = -1;
                if (this.dataInfo != null && this.dataInfo.ids != null) {
                    for (let i = 0; i < this.dataInfo.ids.length; i++) {
                        if (this.newsId === this.dataInfo.ids[i]) {
                            index = i;
                            break;
                        }
                    }
                }
                if (index == 0 && this.dataInfo.pageNo == 1) {
                    this.isOne = 1;
                }
                if (index == this.dataInfo.ids.length - 1 && this.dataInfo.pageNo == this.dataInfo.totalPage) {
                    this.last = 1;
                }
                var contentBDS = this.informationData.content.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "");//去掉html标签和空格
                if (contentBDS.length > 50) {
                    contentBDS = contentBDS.substring(0, 50);
                }
                window._bd_share_config = {
                    share: [{
                        "tag": "share_2",
                        "bdSize": 16,
                    }],
                    common: {
                        bdText: '云图书馆 - ' + this.informationData.title,
                        bdDesc: contentBDS,
                        bdPic: this.imgPath + this.informationData.image || "../../../assets/images/noimg.png",
                        bdUrl: this.informationData.url,
                        bdMini: 1,
                        bdMiniList: ['qzone', 'tsina', 'renren', 'douban']
                    }
                };
                window._bd_share_main.init();
            });
        },

        informationDataList() {
            //文章详情
            return new Promise((resolve, reject) => {
                var url = api.information.info.replace('{fromSearch}', this.fromSearch).replace('{identity}', this.idCard).replace('{newsId}', this.newsId);
                ajaxUtil.ajaxJson(url, null, "GET", (data) => {
                    this.informationData = data;
                    this.praiseCount = data.praiseCount;
                    if (this.informationData.isPraise === 1) {
                        this.isPraise = true;
                    }else {
                        this.isPraise = false;
                    }
                    resolve()
                }, null, this)
            })
        },
        //评论列表
        commentDataList: function () {
            return new Promise((resolve, reject) => {
                var url2 = api.news.commentList.replace('{identity}', '').replace('{newsId}', this.newsId).replace('{pageCount}', this.commentPageCount).replace('{pageNo}', this.pageNo).replace('{readerId}', this.readerId);
                ajaxUtil.ajaxJson(url2, "", "GET", (data) => {
                    this.commentData = data;
                    this.totalPage = data.totalPage;
                    //取消回复框
                    // this.cancel();
                    resolve()
                }, null, this);
            })
        },

        /**
         * 删除评论
         * 评论ID
         * @param id
         * newsId:资讯id、
         */
        delComment: function (id, newsId) {
            var _this = this;
            var url = api.news.delComment;
            var readerId = 0;
            if (StorageUtil.getObject("user") != null) {
                readerId = StorageUtil.getObject("user").readerId;
            }
            var submitData = {
                commentId: id,
                readerId: readerId
            };
            ajaxUtil.ajaxJson(url, submitData, "post", (data) => {
                _this.newsId = newsId;
                _this.commentDataList();
            }, (result) => {

            }, _this);
        },


        delConfirm(id, newsId, isDelComment, listLength, obj) {//
            this.delId = id;
            this.delNewsId = newsId;
            this.isDelComment = Boolean(isDelComment);
            this.isDel = true;
            if (isDelComment == 0 && listLength <= 1) {
                this.delIsClose = true;
            }
            if (this.commentShow != obj.id) {
                this.commentShow = 0
                this.id = -1;
            }
        },

        affirm(param) {
            if (param) {
                this.isDel = false;
                if (this.isDelComment) {
                    this.delComment(this.delId, this.delNewsId);
                } else {
                    this.delReply(this.delId, this.delNewsId);
                }
                this.delId = 0;
                this.delNewsId = 0;
                if (this.delIsClose) {
                    this.delIsClose = false;
                }
            } else {
                this.isMsg = false;
            }
        },

        //查看更多
        more: function (newsId) {
            this.commentPageCount = this.commentPageCount + 10;
            this.newsId = newsId;
            this.commentDataList();
        },

        /**
         *删除评论回复
         * @param id
         * @param newsId
         */
        delReply: function (id, newsId) {
            let url = api.news.delReply;
            let readerId = store.func.getUserObj().readerId;
            let submitData = {
                replyId: id,
                readerId: readerId
            };
            ajaxUtil.ajaxJson(url, submitData, "post", (data) => {
                this.newsId = newsId;
                this.commentDataList();
            }, (result) => {

            }, this);
        },

        cancelDel() {
            this.delId = 0;
            this.delNewsId = 0;
            this.isDel = false;
        },

        //资讯点赞/取消
        praise: function (newsId) {
            if(this.isPraise){
                return;
            }
            this.isPraise = true;
            this.praiseFuc(newsId)
        },
        praiseFuc: function (newsId) {
            let identify =  store.user.idCard || '';
            let url = api.information.praise.replace('{identity}', identify).replace('{newsId}', newsId);
            ajaxUtil.ajaxJson(url, "", "GET", (data) => {
                this.praiseCount = this.praiseCount + 1;
                //this.isPraise = false;
            }, (result) => {
                this.isPraise = false;
            }, this)
        },

        //评论点赞
        isPraiseCommentClick: function (commentId) {
            //用于网络抖动,防止重复提交
            if (this.commentDot) {
                return;
            }
            this.commentDot = true;
            var commentTemp = null;
            var index = 0;
            for (var i = 0; i < this.commentData.resultList.length; i++) {
              if (this.commentData.resultList[i].id == commentId) {
                    commentTemp = this.commentData.resultList[i];
                    index = i;
                    break;
                }
            }
            //未登录
            if (store.func.getUserObj() == null) {
                if (StorageUtil.getObject(commentId) != null) {
                    this.getStoreCommentPraiseCount(commentId, commentTemp);
                    this.commentDot = false;
                    return;
                } else {
                    this.getStoreCommentPraiseCount(commentId, commentTemp);
                    this.commentDot = false;
                    return;
                }
            } else {
                var url = api.news.commentPraise.replace('{commentId}', commentId).replace('{identity}', store.user.idCard);
                ajaxUtil.ajaxJson(url, "", "GET", (data) => {
                    if (commentTemp.isPraise == 1) {//取消
                        commentTemp.praiseCount = commentTemp.praiseCount - 1;
                        commentTemp.isPraise = 0;
                    } else {
                        commentTemp.praiseCount = commentTemp.praiseCount + 1;
                        commentTemp.isPraise = 1;
                    }
                    this.commentDot = false;
                    /* _this.commentDataList(newsId);*/
                }, (result) => {
                    this.commentDot = false;
                }, this);
            }
        },


        getStoreCommentPraiseCount(commentId, commentTemp) {
            if (commentTemp.isPraise == 1) { //取消
                commentTemp.praiseCount = commentTemp.praiseCount - 1;
                commentTemp.isPraise = 0;
            } else {
                commentTemp.praiseCount = commentTemp.praiseCount + 1;
                commentTemp.isPraise = 1;
            }
            StorageUtil.storeObject(commentId, commentTemp.praiseCount);
        },

        checkLogin() {
            if (store.func.getUserObj() == null) {
                this.$refs.islogin.showLogin();
                for(let i=0;i<$('textarea').length;i++){
                    $('textarea')[i].blur()
                }

            }
        },

        //取消回复框
        cancel: function (item) {
            this.replyCommentFlag = 0;
            this.flag = 0;
            this.id = 0;
            this.pubReplyData.content = "";
            if (item == 0) {
                this.cancleComment();
            }
            // this.commentShow = 0;
        },
        /**
         * 资讯评论回复
         * @param id 回复评论id
         * @param newsId 资讯id
         */
        replyDiscuss: function (id, newsId) {
            if (!this.pubReplyData.content.length) {
                this.isMsg = true;
                return false;
            }
            var _this = this;
            var url = api.news.pubReply;
            if (_this.flag == 2) {
                this.pubReplyData.replyId = id;
                this.pubReplyData.commentId = null;
            } else if (_this.flag == 1) {
                this.pubReplyData.commentId = id;
                this.pubReplyData.replyId = null;
            } else {
                return;
            }
            this.pubReplyData.readerId = _this.readerId;
            ajaxUtil.ajaxJson(url, this.pubReplyData, "POST", (data) => {
                _this.pubReplyData.content = "";
                _this.newsId = newsId;
                _this.commentDataList();
            }, null, this);
        },


        success: function () {
            if (store.func.getUserObj() != null) {
                this.readerId = store.func.getUserObj().readerId;
                this.queryData();
            }
        },

        /**
         * fla 1:回复评论，2为回复读者
         * @param flag
         * @param id
         */
        replyComment: function (flag, id, isComment, createTime) {
            this.replyCommentFlag = 1;
            this.flag = flag;
            this.id = id;
            this.createTime = createTime;
            if (isComment) {
                this.commentShow = id;
            }
            this.pubReplyData.content = "";
        },

        cancleComment: function () {
            this.commentShow = 0;
            this.id = 0;
            this.pubReplyData.content = "";
        },


        /**
         * 发表评论资讯
         */
        submitNews: function (newsId) {
            if (this.submitNewsData.content.trim() == null || this.submitNewsData.content.trim() == "") {
                return false;
            }
            if (store.func.getUserObj() == null) {
                this.$refs.islogin.showLogin();
                return;
            }
            if (this.newsDot) {
                return;
            }
            this.newsDot = true;
            if (!this.submitNewsData.content.length) return false;
            var url = api.news.pubComment;
            this.submitNewsData.id = store.func.getUserObj().readerId;
            this.submitNewsData.newsId = newsId;
            ajaxUtil.ajaxJson(url, this.submitNewsData, 'POST', (data) => {
                this.newsDot = false;
                this.submitNewsData.content = '';
                this.newsId = newsId;
                this.commentDataList();
                this.commentShow = 0
                this.id = -1;
            }, (result) => { //错误
                this.newsDot = false;
            }, this);
        },


        //资讯详情
        infoData: function (newsId, isAdd) {
            var _this = this;
            var url = api.information.info.replace('{fromSearch}', _this.fromSearch).replace('{identity}', _this.idCard).replace('{newsId}', newsId);
            ajaxUtil.ajaxJson(url, "", "GET", (data) => {
                _this.informationData = data;
                _this.praiseCount = data.praiseCount;
                _this.newsId = newsId;
                _this.commentDataList();
                if (isAdd === 1) {
                    StorageUtil.storeObject("informationInfo", this.dataInfo);
                }
                CommonUtil.mergeQueryClean(this, {
                    "newsId": newsId,
                    "fromSearch": this.fromSearch,
                    "libCode": this.libCode
                });
            }, (result) => {

            }, _this)
        },


        prev: function (newsId) {
            let index = -1;
            for (let i = 0; i < this.dataInfo.ids.length; i++) {
                if (newsId === this.dataInfo.ids[i]) {
                    index = i;
                    this.newsId = this.dataInfo.ids[i - 1];
                    break;
                }
            }
            if (index !== -1 && index >= 0) {
                if (index === 0) { //上一页
                    this.dataInfo.pageNo = this.dataInfo.pageNo - 1;
                    this.paging(this.dataInfo.pageNo, 1, this.dataInfo.ids, index);
                } else {
                    index = index - 1;
                    let id = this.dataInfo.ids[index];
                    this.infoData(id, 0);
                    CommonUtil.mergeQueryClean(this,{
                        "newsId": id,
                        "fromSearch": this.fromSearch,
                        "libCode": this.libCode
                    });
                    if (index === 0) {
                        if (this.dataInfo.pageNo === 1) {
                            this.isOne = 1;
                            this.last = 0;
                            return;
                        }
                    } else {
                        this.last = 0;
                        this.dataInfo.pageNo = (index + 1) % this.dataInfo.pageCount === 0 ? this.dataInfo.pageNo - 1 : this.dataInfo.pageNo;
                        StorageUtil.storeObject("informationInfo", this.dataInfo);
                    }
                }
            }
        },
        next: function (newsId) {
            let index = -1;
            for (let i = 0; i < this.dataInfo.ids.length; i++) {
                if (newsId == this.dataInfo.ids[i]) {
                    index = i;
                    this.newsId = this.dataInfo.ids[i + 1];
                    break;
                }
            }
            if (index !== -1 && index >= 0) {
                if (index === this.dataInfo.ids.length - 1) { //翻页
                    this.dataInfo.pageNo = this.dataInfo.pageNo + 1;
                    this.paging(this.dataInfo.pageNo, 0, this.dataInfo.ids, index);
                } else {
                    index = index + 1;
                    let id = this.dataInfo.ids[index];
                    this.infoData(id, 0);
                    CommonUtil.mergeQueryClean(this, {
                        "newsId": id,
                        "fromSearch": this.fromSearch,
                        "libCode": this.libCode
                    });
                    if (index == this.dataInfo.ids.length - 1) {
                        if (this.dataInfo.pageNo == this.dataInfo.totalPage) {
                            this.last = 1;
                            this.isOne = 0;
                            return;
                        }
                    } else {
                        this.isOne = 0;
                        this.dataInfo.pageNo = index % this.dataInfo.pageCount == 0 ? this.dataInfo.pageNo + 1 : this.dataInfo.pageNo;
                        StorageUtil.storeObject("informationInfo", this.dataInfo);
                    }
                }
            }
        },
        paging: async function (pageNo, findex, ids, index) {
            var code = store.localtionArea.code;
            var arrId = [];
            var url;
            if (this.libCode != null && this.libCode != '') {
                url = api.library.libNews.replace('{libCode}', this.libCode).replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount);
            } else {
                url = api.information.search.replace('{locationCode}', code).replace('{pageCount}', this.dataInfo.pageCount).replace('{pageNo}', pageNo).replace('{keyword}', "");
            }
            await ajaxUtil.ajaxJson(url, '', 'get', (data) => {
                if (data.resultList != null) {
                    for (var i = 0; i < data.resultList.length; i++) {
                        arrId.push(data.resultList[i].newsId);
                    }
                }
                if (findex == 1) { //上一篇
                    arrId = arrId.concat(ids);
                    index = index + this.dataInfo.pageCount;
                    var id = arrId[index - 1];
                    this.dataInfo.ids = arrId;
                    this.infoData(id, 1);
                } else { //下一篇
                    ids = ids.concat(arrId);
                    var id = ids[index + 1];
                    this.dataInfo.ids = ids;
                    this.infoData(id, 1);
                }
            }, null, this);
        },

        /**
         * 资讯评论回复点赞/取消点赞
         * @param id 回复id
         * commentId:评论id
         */
        isReplyPraise: function (id, newsId, commentId, isPraise) {
            //防止网络抖动重复
            if (this.zanedDot) {
                return;
            }
            this.zanedDot = true;
            var commentTemp = null;//资讯评论
            var repliesTemp = null;//评论回复
            var index = 0;
            for (var i = 0; i < this.commentData.resultList.length; i++) {
                if (this.commentData.resultList[i].id == commentId) {
                    commentTemp = this.commentData.resultList[i];
                    index = i;
                    break;
                }
            }
            if (commentTemp == null) {
                this.zanedDot = false;
                return;
            } else {
                for (var i = 0; i < commentTemp.replies.length; i++) {
                    if (commentTemp.replies[i].id === id) {
                        repliesTemp = commentTemp.replies[i];
                        break;
                    }
                }
            }
            if (repliesTemp == null) {
                this.zanedDot = false;
                return;
            }
            if (store.func.getUserObj() == null) {
                if (StorageUtil.getObject(id) != null) {
                    repliesTemp.praiseCount = StorageUtil.getObject(id);
                    this.getReplyPraiseCount(repliesTemp, id);
                    return;
                } else {
                    this.getReplyPraiseCount(repliesTemp, id);
                    return;
                }
            } else {
                var url = api.news.replyPraise.replace('{identity}', store.func.getUserObj().idCard).replace('{replyId}', id);
                ajaxUtil.ajaxJson(url, '', "get", (data) => {
                    if (repliesTemp.isPraise == 1) {
                        repliesTemp.praiseCount = repliesTemp.praiseCount - 1;
                        repliesTemp.isPraise = 0;
                    } else {
                        repliesTemp.praiseCount = repliesTemp.praiseCount + 1;
                        repliesTemp.isPraise = 1;
                    }
                    /*  _this.commentDataList(newsId);*/
                    this.zanedDot = false;
                }, (result) => {
                    this.zanedDot = false;
                }, this);
            }
        },

        getReplyPraiseCount(repliesTemp, id){
            if (repliesTemp.isPraise == 1) {
                repliesTemp.praiseCount = repliesTemp.praiseCount - 1;
                repliesTemp.isPraise = 0;
            } else {
                repliesTemp.praiseCount = repliesTemp.praiseCount + 1;
                repliesTemp.isPraise = 1;
            }
            StorageUtil.storeObject(id, repliesTemp.praiseCount);
            this.zanedDot = false;
        }
    }
}
